import { constants } from "@newsela/angelou";

import deepReplace from "@/utils/deepReplace";
import { flavors, verticalSnaps, horizontalSnaps } from "./Popout.constants";

const { ui } = constants.colors;

const SPOTLIGHT_Z_INDEX = 5;
const SPOTLIGHT_SHADOW_UNDERLAY_Z_INDEX = 4;
const RAISED_Z_INDEX = 3;

const verticalSnapCssMap = new Map([
  [
    verticalSnaps.top,
    {
      bottom: "100%",
      top: "initial",
    },
  ],
  [
    verticalSnaps.bottom,
    {
      top: "100%",
      bottom: "initial",
    },
  ],
]);

const horizontalSnapCssMap = new Map([
  [
    horizontalSnaps.left,
    {
      left: 0,
    },
  ],
  [
    horizontalSnaps.right,
    {
      right: 0,
    },
  ],
  [
    horizontalSnaps.center,
    {
      left: "50%",
      transform: "translateX(-50%)",
    },
  ],
]);

const snappedCss = ({ verticalSnap, horizontalSnap }) => [
  {
    position: "absolute",
  },
  deepReplace(verticalSnap, verticalSnapCssMap),
  deepReplace(horizontalSnap, horizontalSnapCssMap),
];

const verticalSnapRaisedCssMap = new Map([
  [
    verticalSnaps.top,
    {
      marginBottom: 9,
    },
  ],
  [
    verticalSnaps.bottom,
    {
      marginTop: 9,
    },
  ],
]);

const raisedCss = ({ verticalSnap }) => [
  {
    borderRadius: 8,
    boxShadow: "rgba(0, 0, 0, 0.2) 0px 2px 14px 0px",
    minWidth: "100%",
    zIndex: RAISED_Z_INDEX,
  },
  deepReplace(verticalSnap, verticalSnapRaisedCssMap),
];

export const spotlightCss = {
  zIndex: SPOTLIGHT_Z_INDEX,
};

const spotlightShadowUnderlayCss = {
  position: "fixed",
  top: 0,
  left: 0,
  bottom: 0,
  right: 0,
  zIndex: SPOTLIGHT_SHADOW_UNDERLAY_Z_INDEX,
  backgroundColor: "rgba(0, 0, 0, 0.7)",
  cursor: "pointer",
};

const underlayCssMap = new Map([
  [flavors.spotlight, spotlightShadowUnderlayCss],
  [flavors.raised, { display: "none" }],
]);

export const underlayCss = ({ flavor }) => {
  return deepReplace(flavor, underlayCssMap);
};

export const popoutCss = ({
  isSnapped,
  verticalSnap,
  horizontalSnap,
  flavor,
}) => {
  const flavorCssMap = new Map([
    [flavors.raised, raisedCss({ verticalSnap })],
    [flavors.spotlight, spotlightCss],
  ]);
  const snappedCssMap = new Map([
    [false, undefined],
    [true, snappedCss({ verticalSnap, horizontalSnap })],
  ]);

  // const windowWidth = window.innerWidth;

  // let additionalCss = {};

  // if (windowWidth <= 500) {
  //   additionalCss = {
  //     backgroundColor: 'red',
  //   };
  // }
  return [
    {
      backgroundColor: ui.white[100],
      overflowY: "auto",
      // ...additionalCss,
    },
    deepReplace(flavor, flavorCssMap),
    deepReplace(isSnapped, snappedCssMap),
  ];
};

export const snapTargetCss = {
  position: "relative",
};

export const cancelButtonCss = {
  color: ui.white[100],
  position: "absolute",
  top: 0,
  right: 0,
  margin: "1rem",
};

export const rowCss = {
  display: "block",
  width: "100%",
};

export const spaciousRowCss = {
  "&&": {
    padding: "12px 16px",
    margin: "16px 0",
  },
};

export const denseRowCss = {
  "&&": {
    padding: "8px 24px",
    margin: "8px 0",
  },
};
